import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const TYPOGRAPHY = [
  'body-main',
  'body-para',
  'heading-1',
  'heading-2',
  'heading-3',
  'label',
  'label-small',
  'button',
  'button-small',
];

// Without this, tailwind-merge reads `text-body-main` as a text colour and drops it next to
// `text-n-slate-12` (or the other way round).
const twMerge = extendTailwindMerge<'w3-typography'>({
  extend: {
    classGroups: {
      'w3-typography': [{ text: TYPOGRAPHY }],
    },
  },
});

/** Joins class names and resolves Tailwind conflicts (later classes win). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
